import { Node, mergeAttributes } from '@tiptap/core';

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        pageBreak: {
            insertPageBreak: () => ReturnType;
        };
    }
}

export const PageBreak = Node.create({
    name: 'pageBreak',

    group: 'block',
    atom: true,
    selectable: true,

    parseHTML() {
        return [
            {
                tag: 'div',
                getAttrs: (node) => {
                    if (!(node instanceof HTMLElement)) {
                        return false;
                    }

                    const before = node.style.pageBreakBefore === 'always';
                    const after = node.style.pageBreakAfter === 'always';

                    if (!before && !after) {
                        return false;
                    }

                    // Accept div with page-break style that either:
                    // 1. Has no children
                    // 2. Has a single hidden span child
                    if (node.childElementCount === 0) {
                        return {};
                    }

                    if (node.childElementCount === 1) {
                        const child = node.firstElementChild;
                        if (child?.tagName === 'SPAN' &&
                            (child as HTMLElement).style.display === 'none') {
                            return {};
                        }
                    }

                    return false;
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            mergeAttributes(HTMLAttributes, {
                style: 'page-break-after: always',
            }),
            ['span', { style: 'display: none' }, '\u00A0'],
        ];
    },

    addNodeView() {
        return ({ HTMLAttributes }) => {
            const dom = document.createElement('div');
            dom.className = 'page-break';
            dom.style.pageBreakAfter = 'always';

            if (HTMLAttributes) {
                Object.entries(HTMLAttributes).forEach(([key, value]) => {
                    if (value != null) {
                        dom.setAttribute(key, String(value));
                    }
                });
            }

            const labelSpan = document.createElement('span');
            labelSpan.className = 'page-break__label';

            const i18next = (window as any)?.i18nextEditor ?? (window as any)?.i18next;
            labelSpan.textContent =
                i18next?.t?.('aumico_core_ck_editor_enforce_page_break') ?? 'Page break';

            dom.appendChild(labelSpan);

            return { dom };
        };
    },

    addCommands() {
        return {
            insertPageBreak:
                () =>
                    ({ commands }) =>
                        commands.insertContent({ type: this.name }),
        };
    },
});
